// Module
var code = "<div id=\"bbki-loading-plane-loading-elem\" ib-loading-plane-overlay>\n    <div class=\"ib-background\">\n        <figure>\n            <img class=\"ib-background__img\" data-ng-src=\"{{$root.routes.images}}{{$root.backGroundImage}}\">\n        </figure>\n    </div>\n</div>";
// Exports
module.exports = code;